import { lazy } from 'react';

import { RouterSuspense } from '@/lib';

export const BalanceListAsync = RouterSuspense(
  lazy(() => import('./index.tsx')),
);
